/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type DeckOfferStatusEnum = 'DRAFT' | 'PUBLIC' | 'SOLD' | 'WITHDRAWN' | '11184809';

export const DeckOfferStatusEnum = {
  DRAFT: 'DRAFT' as DeckOfferStatusEnum,
  PUBLIC: 'PUBLIC' as DeckOfferStatusEnum,
  SOLD: 'SOLD' as DeckOfferStatusEnum,
  WITHDRAWN: 'WITHDRAWN' as DeckOfferStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as DeckOfferStatusEnum
};
